import { useCurrentUser } from '@qualio/ui-components';
import { useQuery } from 'react-query';
import { companyApi } from '../api/company';
import { Company } from '../api/model/companySettings';

export const useCompany = (enabled = false) => {
  const currentUser = useCurrentUser();

  return useQuery<Company>({
    queryKey: ['company', currentUser.companyId],
    queryFn: () => companyApi.fetchCompany(currentUser.companyId),
    enabled,
    refetchOnWindowFocus: false,
  });
};
